import React, { FC, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CourierReturnStatusType,
  ICourier,
  useCouriersActions,
} from '../../context/couriers';
import useStyles from './styles';
import { useOrdersActions } from '../../context/orders';
import { Button, IconButton, Typography } from '@material-ui/core';
import { getTimeFromDate } from '@shared/utils';
import Slide from '@material-ui/core/Slide';
import { parseGuestName } from '@src/shared/utils';
import {
  CourierDetailOrderPool,
  CourierDetailOrderType,
  OrderPoolViewType,
} from '../CourierDetailOrderPool';
import {
  useMobileViewActions,
  useMobileViewState,
} from '@src/shared/context/mobile-view';
import {
  EBadgeStatus,
  JetStatusBadge,
} from '@src/shared/components/JetStatusBadges';
import JetFontIcon, {
  JET_FONTICON_ALIASES,
} from '@src/shared/components/JetFontIcon';
import useFMFeatureFlag from '@src/shared/hooks/use-fm-featureflag';
import { JETFM_CRT_COUNTDOWN_FLAG } from '@src/shared/models';
import useBackIn from '../../hooks/use-back-in';
interface CourierDetailProps extends ICourier {
  isMobile?: boolean;
}

export const CourierDetail: FC<CourierDetailProps> = ({
  firstName,
  orderPool,
  returnBack,
  backBy,
  isMobile = false,
  isGuest,
  nextOrderPool,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [passedWaypointsCount, setPassedWaypointsCount] = useState<number>(0);
  //const [showOrderDetails, setShowOrderDetails] = useState<boolean>(false);
  const isCRTCountdownActive = useFMFeatureFlag(JETFM_CRT_COUNTDOWN_FLAG);
  const { setSelectedCourierId } = useCouriersActions();
  const { setSelectedOrderId } = useOrdersActions();
  const { setOrderDetailMobileView } = useMobileViewActions();
  const { showOrderDetailMobileView } = useMobileViewState();
  const {getDistanceDuration} = useBackIn();
  const flushSelections = () => {
    setSelectedCourierId(null);
    setSelectedOrderId(null);
  };

  const closeCourierDetail = () => {
    if (showOrderDetailMobileView) {
      return showOrderDetailsScreen(false);
    }
    return flushSelections();
  }

  useEffect(() => {
    if (orderPool) {
      setPassedWaypointsCount(
        orderPool?.route?.waypoints?.filter(
          (order) => order.isDelivered === true
        ).length
      );
    }
  }, [orderPool]);

  const showOrderDetailsScreen = (flag: boolean) => {
    setOrderDetailMobileView(flag);
  };

  // useEffect(()=> {
  //   if (passedWaypointsCount === orderPool?.totalOrders) {
  //     closeCourierDetail()
  //   }
  // },[passedWaypointsCount])


  return (
    <>
      <div
        className={`${classes.courierDetailWrapper} ${
          isMobile ? 'mobile' : ''
        } ${showOrderDetailMobileView ? 'orderDetail' : ''}`}
      >
        <div className={classes.courierInfoWrapper}>
          <div className={classes.courierDetailInfo}>
            <div className={classes.courierDetailTitle}>
              <Typography variant="h5" className="heading_s_bold">
                {isGuest ? parseGuestName(firstName) : firstName}
              </Typography>
            </div>
            {passedWaypointsCount === orderPool?.totalOrders ||
            !orderPool?.totalOrders ? (
              <JetStatusBadge
                status={returnBack?.status !== CourierReturnStatusType.Returning ? EBadgeStatus.INVERSE : EBadgeStatus.RETURNING}
                badgeText={
                  returnBack &&
                  returnBack.status === CourierReturnStatusType.Returning
                    ? t('courier.returningToRestaurant') 
                    : t('courier.delivering_none')
                }
              ></JetStatusBadge>
            ) : (
              <JetStatusBadge
                status={EBadgeStatus.ACTION}
                badgeText={t('courier.delivering_multiple', {
                  sequence: orderPool?.orderBeingDelivered,
                  total: orderPool?.totalOrders,
                })}
              ></JetStatusBadge>
            )}
           
            {backBy &&
            returnBack?.status === CourierReturnStatusType.Returning &&
            !orderPool?.route.waypoints.filter(
              (orders) => orders.isDelivered === false
            ).length ? (
              <Typography variant="body1" className="body_small_bold">
                {isCRTCountdownActive ? getDistanceDuration(backBy) : <>
                    {t('courier.backBy')} {getTimeFromDate(backBy?.eta)}
                 </>}
              </Typography>
            ) : null}
          </div>

          <IconButton
            onClick={() => { closeCourierDetail() }}
            classes={{ root: classes.closeButton }}
            aria-label="close"
          >
            <JetFontIcon iconname={JET_FONTICON_ALIASES.CLOSE} size={16} />
          </IconButton>
        </div>

        {isMobile ? (
          <>
            {showOrderDetailMobileView ? (
          
                <div className={classes.orderListItemsMobile}>
                  <>
                    {orderPool && orderPool?.route.waypoints.length > 0 ? (
                      <>
                        <CourierDetailOrderPool
                          viewType={OrderPoolViewType.MOBILE}
                          {...orderPool?.route}
                          inOrderPool={CourierDetailOrderType.CURRENT}
                        />
                      </>
                    ) : null}
                    {nextOrderPool &&
                    nextOrderPool?.route?.waypoints.length > 0 ? (
                      <>
                        <CourierDetailOrderPool
                          viewType={OrderPoolViewType.MOBILE}
                          {...nextOrderPool?.route}
                          inOrderPool={CourierDetailOrderType.NEXT}
                        />
                      </>
                    ) : null}
                  </>
                </div>
             
            ) : (
              <div className={classes.mobileShowOrders}>
                <Button
                  className={classes.showOrdersButton}
                  onClick={() => showOrderDetailsScreen(true)}
                  fullWidth
                  variant="outlined"
                  color="primary"
                >
                  <strong>{t('mobile.show_orders')}</strong>
                </Button>
              </div>
            )}
          </>
        ) : null}
      </div>
      {!isMobile ? (
        <>
          {orderPool && orderPool?.route.waypoints.length > 0 ? (
            <>
              <CourierDetailOrderPool
                {...orderPool?.route}
                inOrderPool={CourierDetailOrderType.CURRENT}
              />
            </>
          ) : null}
          {nextOrderPool && nextOrderPool?.route?.waypoints.length > 0 ? (
            <>
              <CourierDetailOrderPool
                {...nextOrderPool?.route}
                inOrderPool={CourierDetailOrderType.NEXT}
              />
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
};

export default CourierDetail;
